/* eslint-disable no-unused-expressions */
/* eslint-disable no-lone-blocks */
import { useAuth0 } from "@auth0/auth0-react";
import CircularProgress from "@mui/material/CircularProgress";
import MenuTabs from "components/MenuTabs/MenuTabs";
import MyButton from "components/MyButton";
import AuthService from "Lib/API/Auth";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { useHistory } from "react-router-dom";
import { clearFilterTable, fetchProducts, filterMailingFields, filterOrder, filterOrderFieldType, filterSelectedAddress } from "./filterSlice";
import "./index.scss";
import { orderFieldMailingLabelsData } from "./orderFieldMailingLabelsData";
import OrderFieldsBulkTagging from "./OrderFieldsBulkTagging";
import OrderFieldsDetails from "./orderFieldsDetails";
import OrderFieldsMailingLabels from "./OrderFieldsMailingLabels";

const tabs = [
  {
    label: "Add fields to the report",
    value: "order-fields",
  },
  {
    label: "Labels output",
    value: "labels-output",
  }, 
  {
    label: "Bulk tagging",
    value: "bulk-tagging",
  }
]



const OrderFields = ({ onClick, goToParameter, id }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const fieldsGroup  = useSelector(
    (state) => state?.filterParams.fieldsGroup
  );

  const [activeTab, setActiveTab] = useState("order-fields");
  const [selectedAddress, setSelectedAddress] = React.useState("active-address");
  const [labelSize, setLabelSize] = React.useState("avery-5160");
  const [addAccountTags, setAddAccountTags] = useState([]);
  const [addContactTags, setAddContactTags] = useState([]);
  const [removeAccountTags, setRemoveAccountTags] = useState([]);
  const [removeContactTags, setRemoveContactTags] = useState([]);
  const [bulkCheckBoxes, setBulkCheckBoxes] = useState({
    addTagsAccounts: false,
    addTagsContacts: false,
    removeAddTagsAccounts: false,
    removeAddTagsContacts: false,
  });
  const [getStatisticsLoading, setStatisticsLoading] = useState(false);
  const [statistics, setStatistics] = useState({
    accounts: "",
    contacts: ""
  });
  const [showStatistics, setShowStatistics] = useState(false);
  const [updateBulkTaggingLoading, setUpdateBulkTaggingLoading] = useState(false);

  const queryParams = new URLSearchParams(window.location.search);
  const selected = useSelector((state) => state.filterParams.fieldsGroup);
  const selectedFieldorders = useSelector(
    (state) => state.filterParams.fieldsOrder
  );
  const collection_Type = useSelector(
    (state) => state.filterParams.collectionDisplayName
  );
  const filterId = queryParams.get("id");
  const filterOrderInitial = useSelector(
    (state) => state?.filterParams?.fieldsOrder
  );
  // const [preSavedData, setPreSavedData] = useState();
  const [filters, setFilters] = useState(selectedFieldorders || []);
  const [token, setToken] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const { getAccessTokenSilently } = useAuth0();
  const [parameter, setParameter] = useState();

  // let token
  React.useEffect(() => {
    async function fetchMyAPI() {
      let parameterDataFromApi = [];
      const token = await getAccessTokenSilently();
      setToken(token);
      await AuthService.getFilterParams(token, true)
        .then((res) => {
          if (res.length) {
            setParameter(res);
            parameterDataFromApi = res;
            // setParameter(data.find((item) => item?.main_contact?.account_id === id));
            // {
            //   filterId
            //     ? AuthService.getFilterById(filterId, token)
            //         .then((res) => {
            //           // setPreSavedData(res);
            //           let newData = filterOrderInitial || [];
            //           // let mapData =
            //           //   filterOrderInitial || res.selectedFieldsOrder;
            //           // const updatedData = mapData.map(
            //           //   ({ fieldName, collectionName }) => {
            //           //     const foundData = _.find(
            //           //       parameterDataFromApi,
            //           //       (item) => item.collectionName === collectionName
            //           //     );
            //           //     if (foundData) {
            //           //       const foundFieldsGroup = _.find(
            //           //         foundData.fieldsGroup,
            //           //         (item) => item.fieldName === fieldName
            //           //       );
            //           //       if (foundFieldsGroup) {
            //           //         newData = [
            //           //           ...newData,
            //           //           {
            //           //             collectionName,
            //           //             displayName: foundFieldsGroup?.displayName,
            //           //             fieldName: foundFieldsGroup?.fieldName,
            //           //           },
            //           //         ];
            //           //       }
            //           //     }
            //           //   }
            //           // );
            //           const uniqueByFieldName = _.uniqBy(newData, "fieldName");
            //           setFilters(uniqueByFieldName);
            //           dispatch(filterOrder(uniqueByFieldName));
            //         })
            //         .catch((err) => {})
            //     : {};
            // }
          }
        })
        .catch((err) => {
          toastr.error("Error", err?.data?.message || "Something went wrong");
        });
    }
    fetchMyAPI();
  }, [filterId, getAccessTokenSilently]);
  /**
   * Adds value to filter by given key
   * @param {any} value
   */
  const addFilter = (filter, item) => {
    const filterData = [
      ...filters,
      {
        collectionName: item,
        fieldName: filter.fieldName,
        displayName: filter?.displayName,
      },
    ];
    setFilters(filterData);
    dispatch(filterOrder(filterData));
  };

  // React.useEffect(() => {
  //   dispatch(filterOrder(filters));
  // }, [filters]);

  /**
   * Remove object value from given
   * @param {any} value, object key
   */

  const removeFilter = (value, endIndex) => {
    // const foundIndex = _.findIndex(filters, (item) => item === value)
    // const newData = filters.splice(foundIndex, 0);
    const newData = filters.filter((item) => item?.fieldName !== value);
    setFilters(newData);
    dispatch(filterOrder(newData));
  };

  /**
   * Handles the click event of the tag
   * @param {any} filterName, Name of the filter
   */
  const handleClick = (filter, item) => {
    // if (collection_Type == item?.collectionName) {
    addFilter(filter, item.collectionName);
    // } else {
    //   toastr.warning(
    //     "warning",
    //     `You can only order fields for ${collection_Type}`
    //   );
    // }
  };

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };
  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const items = reorder(
      filters,
      result.source.index,
      result.destination.index
    );
    setFilters(items);
    dispatch(filterOrder(items));
  };


  
  const getFilterSelectedField = useCallback(() => {
    const mapField = (key, operator, oprInputType, displayName, values, collectionName) => {
      const lineIndex = 0;
      const lineContainsArray = values ? Array.isArray(values[lineIndex]) : true;
      const hasComma = values?.includes(',');
  
      return {
        fieldName: key,
        operator,
        type: oprInputType,
        displayName,
        fieldValue: lineContainsArray
          ? values?.[0] === null ? "" : values?.[0]
          : values === null ? ""
            : operator === 7 || operator === 8
              ? hasComma ? values?.split(' , ') : [values]
              : oprInputType === 'date' && hasComma
                ? values.split(',').map((date) => date.trim())
                : values || [],
        collectionName: collectionName || "",
      };
    };
    const selectedField = Object.keys(fieldsGroup).map(key =>
      mapField(
        key,
        fieldsGroup[key].operator,
        fieldsGroup[key].oprInputType,
        fieldsGroup[key].displayName,
        fieldsGroup[key].values,
        fieldsGroup[key].collectionName
      )
    );
  

  
    const addTags = (tags, fieldName, operator, displayName, collectionName) => {
      if (tags?.length) {
        const existingTags = selectedField.find(item => item?.fieldName === fieldName && item?.operator === operator);
        if (existingTags && existingTags !== undefined) {
          existingTags.fieldValue = [...existingTags.fieldValue, ...tags];
        } else {
          selectedField.push({
            fieldName,
            operator,
            type: "multiSelect",
            displayName,
            fieldValue: tags,
            collectionName,
          });
        }
      }
    };
  
    addTags(addAccountTags, "account.tags", 8, "Account Tags", "Account");
    addTags(removeAccountTags?.map(item => item?.label), "account.tags", 7, "Account Tags", "Account");
    addTags(addContactTags, "tags", 8, "Contact Tags", "Members");
    addTags(removeContactTags?.map(item => item?.label), "tags", 7, "Contact Tags", "Members");
  

    return selectedField;
  }, [
    fieldsGroup,
    addAccountTags,
    bulkCheckBoxes.addTagsAccounts,
    removeAccountTags,
    bulkCheckBoxes.removeAddTagsAccounts,
    addContactTags,
    bulkCheckBoxes.addTagsContacts,
    removeContactTags,
    bulkCheckBoxes.removeAddTagsContacts,
  ]);
  
    
  const sendMailingLabelsHandler = () => {
    const filterData = orderFieldMailingLabelsData(selectedAddress)
    setFilters(filterData);
    dispatch(filterOrder(filterData))
  }                    

  const bulkTaggingHandler = async () => {
    const bodyData = {
      isBulkTag: true,
      selectedFields: getFilterSelectedField(),
    };
    setStatisticsLoading(true);
    try {
      const response = await AuthService.sendFilterParams(bodyData, token);
      setStatistics({
        accounts: response?.[0]?.accounts,
        contacts: response?.[0]?.contacts,
      });
      setShowStatistics(true);
    } catch (error) {
      console.error('Error occurred:', error);
      toastr.error("Error", error?.data?.message)
      setShowStatistics(false);
    }
    finally {
      setStatisticsLoading(false);
    }
  }
  const updateTaggingHandler = async() => {
    const bodyData = {
      selectedFields: getFilterSelectedField(),
      addTagsAccount: addAccountTags,
      addTagsContacts: addContactTags,
      removeTagsAccount: removeAccountTags?.map((item) => item?.label),
      removeTagsContacts: removeContactTags?.map((item) => item?.label),
    };
    setUpdateBulkTaggingLoading(true);
    try {
      const response = await AuthService.updateBulkTag({data:bodyData, token});
      toastr.success("Success", response?.message);
      history.push("/report");
    } catch (error) {
      console.error('Error occurred:', error);
      toastr.error("Error", error?.data?.message)
    }
    finally {
      setUpdateBulkTaggingLoading(false);
    }
  }

  async function sendData() {
    if(activeTab === "bulk-tagging") {
      showStatistics ? updateTaggingHandler() : bulkTaggingHandler()
      return;
    }
    if(activeTab === "labels-output") sendMailingLabelsHandler();
    dispatch(clearFilterTable());
    onClick();
    dispatch(filterOrderFieldType(activeTab));
    dispatch(filterSelectedAddress(selectedAddress));
    dispatch(fetchProducts({ data: { filters }, token, pagination: { items_per_page: 25, current_page: 1 }, sort: {} }));
  }

  const getFilterByid = async () => {
    if (id) {
      const token = await getAccessTokenSilently();
      await AuthService.getFilterById(id, token).then((res) => {
        let tempFilter = res?.selectedFields?.map((ele) => {
          let tempStr = "";
          ele?.fieldName.split("_").forEach((ele) => {
            const str2 = ele.charAt(0).toUpperCase() + ele.slice(1);
            tempStr += " " + str2;
          });
          return {
            collectionName: ele?.collectionName,
            displayName: String(tempStr),
            fieldName: ele?.fieldName,
            operator: ele?.operator,
            oprInputType: "text",
            values: ele?.fieldValue[0],
          };
        });
        // setFilters(tempFilter);
        if (filters.length === 0) {
          setFilters(res?.selectedFieldsOrder);
        }
      }).catch((err) => toastr.error("Error", err?.data?.message));
    }
  };

  React.useEffect(() => {
    getFilterByid();
  }, []);

  React.useEffect(() => {
    localStorage.setItem("goto", "parameter");
  }, []);


  const onTabsChange = (tab) => {
    setActiveTab(tab);
  };


  const checkBulkTaggingDisabled = () => {
    let valid = false;
    if ((showStatistics ? (statistics.accounts || statistics.contacts) : true) && (bulkCheckBoxes.addTagsAccounts && addAccountTags.length ||
      bulkCheckBoxes.addTagsContacts && addContactTags.length ||
      bulkCheckBoxes.removeAddTagsAccounts && removeAccountTags.length ||
      bulkCheckBoxes.removeAddTagsContacts && removeContactTags.length)) {
      valid = true;
    }

    return !valid;
  }

  const checkNextButtonDisabled = () => {
    return activeTab === "order-fields" ? !filters?.length : activeTab === "bulk-tagging" ? checkBulkTaggingDisabled() : false;
  }


  useEffect(() => {
    setShowStatistics(false);
  }, [addAccountTags, addContactTags, removeAccountTags, removeContactTags, bulkCheckBoxes]);

  const displayContent = {
    "order-fields":  (
        <OrderFieldsDetails 
          searchTerm={searchTerm} 
          setSearchTerm={setSearchTerm}
          parameter={parameter}
          filters={filters}
          onDragEnd={onDragEnd}
          removeFilter={removeFilter}
          handleClick={handleClick}
        />
      ),
    "labels-output": (
      <OrderFieldsMailingLabels 
      selectedAddress={selectedAddress}
      setSelectedAddress={setSelectedAddress}
      labelSize={labelSize}
      setLabelSize={setLabelSize}
    />
    ),
    "bulk-tagging": (
      <OrderFieldsBulkTagging 
        addAccountTags={addAccountTags}
        setAddAccountTags={setAddAccountTags}
        addContactTags={addContactTags}
        setAddContactTags={setAddContactTags}
        removeAccountTags={removeAccountTags}
        setRemoveAccountTags={setRemoveAccountTags}
        removeContactTags={removeContactTags}
        setRemoveContactTags={setRemoveContactTags}
        bulkCheckBoxes={bulkCheckBoxes}
        setBulkCheckBoxes={setBulkCheckBoxes}
        statistics={statistics}
        showStatistics={showStatistics}
        getStatisticsLoading={getStatisticsLoading}
      />
    )
  }



  return (
    <div className="parameter-values">
      <div className="parameter-values__tabs">
        <MenuTabs
          tabs={tabs}
          activeTab={activeTab}
          onTabsChange={onTabsChange}
          tabWidth='12rem'
        />
      </div>
      {displayContent[activeTab]}
      <hr />
      <div className="next-previous d-flex align-items-center">
        <MyButton
          content="Previous"
          style={{ width: "100px", height: "40px", marginBottom: "25px", marginLeft: "150px" }}
          onClick={goToParameter}
        />
        <MyButton
          content={(getStatisticsLoading || updateBulkTaggingLoading) ? (
              <div className="d-flex justify-content-center align-items-center">
                  <CircularProgress
                    size={20}
                    style={{
                      color: "#FFFFFF"
                    }}
                  />
              </div>
          )
            : (showStatistics && activeTab === "bulk-tagging") ? "Update" : "Next"}
          style={{ width: "100px", height: "40px", marginBottom: "25px", marginRight: "25px" }}
          onClick={sendData}
          disabled={checkNextButtonDisabled()}
        />
      </div>
    </div>
  );
};
export default OrderFields;
